export const MONSTERS = {
  rat: {
    id: "rat",
    name: "巨鼠",
    texture: "provided-rat",
    maxHealth: 18,
    damage: 8,
    contactDamage: 4,
    contactCooldownMs: 750,
    speed: 132,
    attackRange: 31,
    attackCooldownMs: 850,
    windupMs: 260,
    recoverMs: 260,
    attackKind: "pounce",
    dashSpeed: 300,
    dashDurationMs: 180,
    dashHitRange: 36,
    threat: 2,
    armor: 0,
    color: 0xffffff,
    scale: 2.4,
    bodyRadius: 13,
  },
  tomb_scout: {
    id: "tomb_scout",
    name: "墓穴斥候",
    texture: "provided-tomb-scout",
    maxHealth: 24,
    damage: 9,
    contactDamage: 4,
    contactCooldownMs: 760,
    speed: 120,
    attackRange: 74,
    attackCooldownMs: 820,
    windupMs: 230,
    recoverMs: 280,
    attackKind: "dash",
    dashSpeed: 310,
    dashDurationMs: 180,
    dashHitRange: 36,
    threat: 3,
    armor: 0,
    color: 0xffffff,
    scale: 2.4,
    bodyRadius: 13,
  },
  goblin_bat: {
    id: "goblin_bat",
    name: "棒棍哥布林",
    texture: "provided-goblin-bat",
    maxHealth: 62,
    damage: 15,
    contactDamage: 7,
    contactCooldownMs: 900,
    speed: 54,
    attackRange: 42,
    attackCooldownMs: 1100,
    windupMs: 430,
    recoverMs: 380,
    attackKind: "melee",
    threat: 5,
    armor: 2,
    color: 0xffffff,
    scale: 2.4,
    bodyRadius: 13,
  },
  goblin_dagger: {
    id: "goblin_dagger",
    name: "匕首哥布林",
    texture: "provided-goblin-dagger",
    maxHealth: 30,
    damage: 10,
    contactDamage: 5,
    contactCooldownMs: 780,
    speed: 108,
    attackRange: 88,
    attackCooldownMs: 780,
    windupMs: 220,
    recoverMs: 300,
    attackKind: "dash",
    dashSpeed: 300,
    dashDurationMs: 180,
    dashHitRange: 38,
    threat: 4,
    armor: 0,
    color: 0xffffff,
    scale: 2.4,
    bodyRadius: 13,
    stealth: true,
  },
  plague_mage: {
    id: "plague_mage",
    name: "瘟疫法師",
    texture: "provided-plague-mage",
    maxHealth: 36,
    damage: 12,
    contactDamage: 4,
    contactCooldownMs: 950,
    speed: 76,
    attackRange: 360,
    preferredRangeMin: 170,
    preferredRangeMax: 280,
    attackCooldownMs: 1450,
    windupMs: 650,
    recoverMs: 620,
    attackKind: "spell",
    projectilePattern: "spell",
    projectileDamage: 16,
    projectileSpeed: 172,
    projectileTexture: "spell-projectile",
    projectileAnimation: "spell-projectile-flight",
    projectileScale: 0.09,
    projectileRadius: 10,
    projectileVisual: "fireball",
    threat: 5,
    armor: 0,
    color: 0xffffff,
    scale: 2.4,
    bodyRadius: 13,
  },
  crypt_archer: {
    id: "crypt_archer",
    name: "墓室弓手",
    texture: "provided-crypt-archer",
    maxHealth: 44,
    damage: 10,
    contactDamage: 4,
    contactCooldownMs: 920,
    speed: 70,
    attackRange: 350,
    preferredRangeMin: 180,
    preferredRangeMax: 275,
    attackCooldownMs: 1280,
    windupMs: 520,
    recoverMs: 540,
    attackKind: "ranged",
    projectilePattern: "single",
    projectileDamage: 12,
    projectileSpeed: 225,
    projectileTexture: "fantasy-arrow",
    projectileScale: 2.7,
    projectileRadius: 6,
    projectileRotationOffset: 0,
    threat: 6,
    armor: 1,
    color: 0xffffff,
    scale: 2.4,
    bodyRadius: 13,
  },
  robot_gunner: {
    id: "robot_gunner",
    name: "機械槍手",
    texture: "provided-robot-gunner",
    maxHealth: 52,
    damage: 11,
    contactDamage: 6,
    contactCooldownMs: 950,
    speed: 62,
    attackRange: 390,
    preferredRangeMin: 190,
    preferredRangeMax: 310,
    attackCooldownMs: 1650,
    windupMs: 520,
    recoverMs: 720,
    attackKind: "laser",
    projectilePattern: "burst",
    projectileDamage: 8,
    projectileSpeed: 245,
    projectileTexture: "laser-projectile",
    projectileScale: 2.5,
    projectileRadius: 6,
    projectileVisual: "laser",
    projectileRotationOffset: -Math.PI / 2,
    projectileTint: 0x75e9ff,
    threat: 7,
    armor: 2,
    color: 0xffffff,
    scale: 2,
    bodyRadius: 16,
    shadowOffsetY: 12,
    shadowScale: 2.4,
    machine: true,
  },
  steel_spider: {
    id: "steel_spider",
    name: "鋼鐵蜘蛛",
    texture: "provided-steel-spider",
    maxHealth: 78,
    damage: 15,
    contactDamage: 8,
    contactCooldownMs: 950,
    speed: 46,
    attackRange: 340,
    preferredRangeMin: 150,
    preferredRangeMax: 260,
    attackCooldownMs: 1350,
    windupMs: 560,
    recoverMs: 620,
    attackKind: "ranged",
    projectilePattern: "single",
    projectileDamage: 15,
    projectileSpeed: 210,
    projectileTexture: "enemy-projectile",
    projectileScale: 1.8,
    threat: 8,
    armor: 3,
    color: 0xffffff,
    scale: 2,
    bodyRadius: 16,
    shadowOffsetY: 12,
    shadowScale: 2.4,
    machine: true,
  },
  void_knight: {
    id: "void_knight",
    name: "虛空騎士",
    texture: "provided-void-knight",
    maxHealth: 90,
    damage: 19,
    contactDamage: 9,
    contactCooldownMs: 900,
    speed: 40,
    attackRange: 48,
    attackCooldownMs: 1380,
    windupMs: 540,
    recoverMs: 720,
    attackKind: "melee",
    threat: 9,
    armor: 5,
    color: 0xffffff,
    scale: 2.55,
    bodyRadius: 16,
    shadowOffsetY: 12,
    shadowScale: 2.3,
    elite: true,
  },
  machine_guard: {
    id: "machine_guard",
    name: "重裝守衛",
    texture: "provided-machine-guard",
    maxHealth: 118,
    damage: 22,
    contactDamage: 10,
    contactCooldownMs: 900,
    speed: 34,
    attackRange: 64,
    attackCooldownMs: 1550,
    windupMs: 620,
    recoverMs: 850,
    attackKind: "dash",
    dashSpeed: 330,
    dashDurationMs: 260,
    dashHitRange: 48,
    threat: 11,
    armor: 6,
    color: 0xffffff,
    scale: 2.45,
    bodyRadius: 18,
    shadowOffsetY: 14,
    shadowScale: 2.8,
    machine: true,
    elite: true,
  },
};

export const NORMAL_MONSTER_POOLS = [
  ["rat", "tomb_scout", "goblin_bat"],
  ["rat", "tomb_scout", "goblin_dagger", "plague_mage", "crypt_archer"],
  ["rat", "tomb_scout", "goblin_bat", "goblin_dagger", "plague_mage", "crypt_archer"],
  ["goblin_dagger", "plague_mage", "crypt_archer", "void_knight", "robot_gunner", "steel_spider"],
  ["goblin_bat", "goblin_dagger", "plague_mage", "crypt_archer", "void_knight", "robot_gunner", "steel_spider", "machine_guard"],
];
